import { Link } from 'react-router-dom';
import type { Show } from '@/mocks/shows';

interface ShowCardProps {
  show: Show;
}

export default function ShowCard({ show }: ShowCardProps) {
  return (
    <Link
      to={`/article/${show.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
      data-product-shop
    >
      {/* Image */}
      <div className="relative w-full aspect-[4/3] overflow-hidden">
        <img
          src={show.image}
          alt={`${show.title} - 屁屁影院免费在线观看`}
          title={`${show.title} - 屁屁影院免费在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/30 transition-colors duration-300 flex items-center justify-center">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <i className="ri-play-fill text-xl"></i>
          </span>
        </div>
        {/* Badge */}
        {show.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
            最新
          </span>
        )}
        {show.isHot && !show.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
            热播
          </span>
        )}
        {/* Rating */}
        <span className="absolute top-2 right-2 px-1.5 py-0.5 text-xs bg-foreground-950/70 text-accent-500 rounded-md flex items-center gap-0.5 whitespace-nowrap">
          <i className="ri-star-fill text-[10px] w-3 h-3 flex items-center justify-center"></i>
          {show.rating}
        </span>
        {/* Episodes */}
        <span className="absolute bottom-2 right-2 px-1.5 py-0.5 text-xs bg-foreground-950/70 text-background-50 rounded-md whitespace-nowrap">
          {show.episodes}
        </span>
      </div>

      {/* Info */}
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {show.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500 bg-secondary-100 px-1.5 py-0.5 rounded whitespace-nowrap">
            {show.subcategory}
          </span>
          <span className="text-xs text-foreground-400">{show.year}</span>
        </div>
        <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">
          {show.description}
        </p>
      </div>
    </Link>
  );
}